import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import { useTranslation } from 'react-i18next';
import { useStore } from '@/models';
import { Button, Form, Input } from 'antd';
import CaptchaBtn from '@/components/captchaBtn';
import cx from 'classnames';
import cs from '../../index.module.scss';
import { isFromMobile } from '@/utils/location';

const LastStep: React.FC = () => {
  const { t } = useTranslation();
  const { account, ui } = useStore();
  const { secondSuffix, getWsToken, loginUserName, fetchUserInfo, loginTokenInfo } = account;

  const { msg, code } = loginTokenInfo;
  const { telCountryCode, username } = loginUserName;
  const { push } = useHistory();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false); // 第一个登录按钮
  const showEmailCode = [-10021, -10025].includes(code);
  const showGoogleCode = code === -10025;
  const subLogin = async params => {
    const data1 = {
      prefixAuth: msg,
      ...params,
    };
    secondSuffix(data1)
      .then(async res => {
        if (res) {
          await getWsToken();
          await fetchUserInfo();
          push(isFromMobile() ? '/home' : '/');
          ui.hideLoginModal();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };
  const onFinish = (values: any) => {
    setLoading(true);
    const { googleCode, emailCode } = values;

    subLogin({ googleCode, emailCode });
  };

  return (
    <div className={cs.content}>
      <div className={cx(cs.content_info)}>
        <Form
          form={form}
          name="basic"
          labelCol={{ flex: 1 }}
          wrapperCol={{ flex: 1 }}
          labelAlign="left"
          initialValues={{ telCountryCode: '86' }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="vertical"
        >
          {showEmailCode && (
            <Form.Item name="emailCode" rules={[{ required: true, message: t('common.qsryxyzm') }]}>
              <Input
                className="bgIptAddonAfter"
                placeholder={t('common.yxyam')}
                addonAfter={<CaptchaBtn username={username} telCountryCode={telCountryCode} isSended />}
              />
            </Form.Item>
          )}

          {showGoogleCode && (
            <Form.Item name="googleCode" rules={[{ required: true, message: t('common.AuthenticationCodePlace') }]}>
              <Input placeholder={t('common.AuthenticationCode')} className="iptDefault" />
            </Form.Item>
          )}

          <div className={cs.btn}>
            <Button
              loading={loading}
              type="primary"
              htmlType="submit"
              className={cx('btnPrimary', cs.registerBtn)}
              style={{ height: '40px', width: '100%' }}
            >
              {t('btn.signIn')}
            </Button>
          </div>
          <div
            className={cx(cs.findpsw, 'pointer', 'font-700')}
            onClick={() => {
              // push('/findpsw');
              ui.hideLoginModal();
              ui.showFindPwdModal();
            }}
          >
            {t('common.forgetpsd')}?
          </div>
        </Form>
      </div>
    </div>
  );
};

export default observer(LastStep);
